export default "__VITE_ASSET__CESDLOz3__"